<div class="main-content">
  
  <router-outlet></router-outlet>
</div>
<!-- <footer class="py-5">
  <div class="container">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-6">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ test | date: "yyyy" }} <a href="http://www.royalstudios.com/" class="font-weight-bold ml-1" target="_blank">Royal Gear Studios</a>
        </div>
      </div>
      <div class="col-xl-6">
        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
          <li class="nav-item">
            <a href="http://www.royalstudios.com/" class="nav-link" target="_blank">RGS</a>
          </li>
          <li class="nav-item">
            <a href="https://rsicmohali.com/" class="nav-link" target="_blank">About Us</a>
          </li>
          <li class="nav-item">
            <a href="https://rsicmohali.com/contact/" class="nav-link" target="_blank">Contact Us</a>
          </li>
          <li class="nav-item">
            <a href="https://github.com/creativetimofficial/argon-dashboard-angular/blob/master/LICENSE.md" class="nav-link" target="_blank">MIT License</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer> -->
